export function Landing() {
  return (
    <div className="hero">
      <p className="eyebrow">Conference Room Scheduling</p>
      <h1>Real-time room status <span className="accent">across the office</span></h1>
      <p>
        Wall-mounted iPads outside each conference room, backed by the real
        Microsoft 365 room mailbox calendars. Internal use only.
      </p>
    </div>
  );
}
